<template>
    <div>
        <div class="action-header">
            <el-button @click="showDialog" icon="el-icon-plus" type="primary">新建用户</el-button>
        </div>
        <Table />
        <Pagination />
        <DialogUser />
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DIALOG_ADD } from '../../libs/enum.js';
import Table from './table';
import Pagination from './pagination';
import DialogUser from './dialog.user';

const { mapActions } = createNamespacedHelpers('user');

export default {
    components: { Table, Pagination, DialogUser },
    methods: {
        ...mapActions(['changeDialog', 'getUsers']),
        showDialog() {
            this.changeDialog({ visible: true, type: DIALOG_ADD });
        },
    },
    mounted() {
        this.getUsers();
    },
};
</script>

<style lang="less" scoped>
.action-header {
    margin-bottom: 20px;
}
</style>
